export default function SectionHead({ eyebrow, title, subtitle, align = "left", dark = false }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <p className={`eyebrow ${dark ? "!text-brand-gold" : ""}`} data-testid="section-eyebrow">{eyebrow}</p>}
      <h2 className={`mt-3 text-3xl sm:text-4xl lg:text-[2.75rem] font-extrabold leading-[1.12] ${dark ? "text-white" : "text-brand-dark"}`}>{title}</h2>
      {subtitle && <p className={`mt-4 text-base md:text-lg leading-relaxed ${dark ? "text-white/60" : "text-brand-muted"}`}>{subtitle}</p>}
    </div>
  );
}
